<template>

<app-wrapper>

	<app-banner />
	
	<app-wrapper :content="true" class="request">

		<app-wrapper>

			<app-text :text="$state.page.content" />

			<a href="https://www.google.com/search?q=luqmani+thompson#lrd=0x48761be4caa5e553:0xea1c7f8aa07d2d00,1,,,,&topic=mid:/m/0cbx95" target="_blank" class="request-google">

				<b>What our clients say</b>

				<span>Click to see reviews from our clients.</span>

			</a>

		</app-wrapper>

		<app-wrapper>

			<app-text text="<h2>Request a consultation</h2>" />

			<com-form />

		</app-wrapper>

	</app-wrapper>

</app-wrapper>

</template>

<script>

export default {

	components: {

		'com-form': () => import('./request/Form')

	}

}

</script>

<style scoped>

.request {
	padding: 64px 20px!important;
	display: grid;
	align-items: start;
	grid-template-columns: 408px auto;
	grid-gap: 100px;
}

.is-tablet .request {
	padding: 48px 20px!important;
	grid-template-columns: 1fr;
	grid-gap: 0px;
}

.is-mobile .request {
	padding: 32px 20px!important;
	grid-template-columns: 1fr;
	grid-gap: 0px;
}

.request-google {
	background-color: #485CC7;
	border-radius: 10px;
	padding: 20px 20px 20px 130px;
	margin-top: 100px;
	background-image: url('data:image/png;base64,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');
	background-repeat: no-repeat;
	background-size: 80px 80px;
	background-position: 30px 50%;
	height: 144px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	cursor: pointer;
}

.is-tablet .request-google {
	margin: 48px 0px;
}

.is-mobile .request-google {
	margin: 32px 0px;
	padding: 10px 10px 10px 100px;
	background-size: 40px 40px;
}

.request-google:hover {
	background-color: #2f3f99;
}

.request-google b {
	font-size: 22px;
	font-weight: 700;
	color: #fff;
	margin-bottom: 4px;
}

.is-mobile .request-google b {
	font-size: 18px;
	line-height: 24px;
}

.request-google span {
	font-size: 16px;
	color: #fff;
	font-weight: 400;
	line-height: 26px;
}

.is-mobile .request-google span {
	font-size: 14px;
	line-height: 18px;
}

</style>
